<template>

  <div>

    <list-add-new
      :is-add-new-sidebar-active.sync="isAddNewSidebarActive"
      :package-options="packageOptions"
      @refetch-data="refetchData"
    />

    <details-sidebar
      :is-details-sidebar-active.sync = "isDetailsSidebarActive"
      :details-data = "details"
    />

    <!-- Filters -->
    <list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="isAddNewSidebarActive = true"
              >
                <span class="text-nowrap">Add Organization</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: index -->
        <template #cell(#)="data">
          <span class="text-center" :title="data.item.id">
              {{ data.index + 1 }}
          </span>
        </template>

        <!-- Column: Name -->
        <template #cell(name)="data">
          <b-media vertical-align="center">
            <b-link
              class="font-weight-bold d-block text-nowrap"
              :to="{ name: 'organization-view', params: { id: data.item.id } }"
            >
              {{ data.item.name }}
            </b-link>
            <small class="text-muted">{{ data.item.slug }}</small>
          </b-media>
        </template>

        <!-- Column: Email
        <template #cell(email)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.contact_email }}</span>
          </div>
        </template> -->

        <!-- Column: Phone
        <template #cell(phone)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.item.contact_phone }}</span>
          </div>
        </template> -->

        <!-- Column: Plan -->
        <template #cell(plan)="data">
          <span class="text-capitalize" v-if="data.item.package">
            {{ data.item.package.title }}
          </span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.is_approved, data.item.is_archived)}`"
            class="text-capitalize"
          >
            {{ showStatus(data.item.is_approved, data.item.is_archived) }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'organization-view', params: { id: data.item.id } }">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">Details</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'organization-view', params: { id: data.item.id } }">
              <feather-icon icon="UsersIcon" />
              <span class="align-middle ml-50">Users</span>
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: 'organization-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item v-if="data.item.is_approved != 1" @click="changeApproveStatus(data.item.id, 1)">
              <feather-icon icon="CheckIcon" />
              <span v-if="data.item.is_approved != 1" class="align-middle ml-50">Approved</span>
            </b-dropdown-item>

            <b-dropdown-item v-else-if="data.item.is_approved == 1 && !data.item.is_archived" @click="changeArchiveStatus(data.item.id, 1)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Archive</span>
            </b-dropdown-item>

            <b-dropdown-item v-else-if="data.item.is_approved == 1 && data.item.is_archived" @click="changeArchiveStatus(data.item.id, 0)">
              <feather-icon icon="RefreshCwIcon" />
              <span  class="align-middle ml-50">Unarchive</span>
            </b-dropdown-item>

            <b-dropdown-item v-if="data.item.is_approved == 0" @click="changeApproveStatus(data.item.id, 2)">
              <feather-icon icon="XIcon" />
              <span class="align-middle ml-50">Rejected</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import ListFilters from './ListFilters.vue'
import useList from './useList'
import orgStoreModule from '../orgStoreModule'
import ListAddNew from './ListAddNew.vue'
import DetailsSidebar from './Details.vue'

export default {
  components: {
    ListFilters,
    ListAddNew,
    DetailsSidebar,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      details: ''
    }
  },
  methods: {
    // change archive starus
    changeArchiveStatus(id, is_archived) {
      var status = is_archived ? 'archive' : 'active'
      this.$swal({
        title: 'Are you confirm?',
        text: `You want to ${status} this!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-org/changeArchiveStatus', {id: id, is_archived: is_archived})
            .then((response) => {
              if(response.data.status == 0 || response.data.status == 1){
                this.$swal({
                  icon: 'success',
                  title: response.data.message,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refetchData();
              }
            })
          
        }
      })
    },
    // change approved starus
    changeApproveStatus(id, is_approved) {
      var status = is_approved ? 'approve' : 'reject'
      this.$swal({
        title: 'Are you confirm?',
        text: `You want to ${status} this!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('app-org/changeApproveStatus', {id: id, is_approved: is_approved})
            .then((response) => {
              if(response.data.status == 0 || response.data.status == 1){
                this.$swal({
                  icon: 'success',
                  title: response.data.message,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                this.refetchData();
              }
            })
          
        }
      })
    },
    detailsView(details_data) {
      this.details = details_data;
      this.isDetailsSidebarActive = true;
    }
  },
  setup() {
    const ORG_APP_STORE_MODULE_NAME = 'app-org'

    // Register module
    if (!store.hasModule(ORG_APP_STORE_MODULE_NAME)) store.registerModule(ORG_APP_STORE_MODULE_NAME, orgStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ORG_APP_STORE_MODULE_NAME)) store.unregisterModule(ORG_APP_STORE_MODULE_NAME)
    })

    const getPackageData = async () => {
      store.dispatch('app-org/fetchPackageOption')
        .then((response) => {
          if(response.data.status == 1)
            packageOptions.value = response.data.data
      }).catch(error=> {})
    }

    onMounted(getPackageData)
    const packageOptions = ref([])

    const isAddNewSidebarActive = ref(false)
    const isDetailsSidebarActive = ref(false)

    const statusOptions = [
      { label: 'All', value: null },
      { label: 'Active', value: "Active" },
      { label: 'Archived', value: "Archived" },
      { label: 'Pending', value: "Pending" },
      { label: 'Rejected', value: "Rejected" },
    ]

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      // UI
      resolveStatusVariant,
      showStatus,

      // Extra Filters
      statusFilter,
    } = useList()

    return {

      // Sidebar
      isAddNewSidebarActive,
      isDetailsSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveStatusVariant,
      showStatus,

      statusOptions,
      packageOptions,

      // Extra Filters
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
